var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      key: _vm.stateId,
      staticClass: "single-question-wrapper",
      attrs: { draggable: "true" },
      on: {
        dragstart: function ($event) {
          return _vm.startDrag($event, _vm.index)
        },
        drop: function ($event) {
          return _vm.onDrop($event, _vm.index)
        },
        dragover: function ($event) {
          $event.preventDefault()
        },
        dragenter: function ($event) {
          $event.preventDefault()
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "single-question-extensions" },
        [
          _c("MessageDelaySlider", {
            model: {
              value: _vm.value.delay,
              callback: function ($$v) {
                _vm.$set(_vm.value, "delay", $$v)
              },
              expression: "value.delay",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "single-question" }, [
        _c(
          "div",
          { staticClass: "control-buttons" },
          [
            _c(
              "md-button",
              {
                staticClass: "md-icon-button md-mini",
                on: {
                  click: function () {
                    return _vm.onRemoved(_vm.value.id)
                  },
                },
              },
              [_c("md-icon", [_vm._v("delete")])],
              1
            ),
            _vm._v(" "),
            _c(
              "md-button",
              { staticClass: "md-icon-button md-mini" },
              [_c("md-icon", [_vm._v("swap_horiz")])],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "message-variants" }, [
          _c("div", { staticClass: "header-content" }, [
            _c("span", { staticClass: "label" }, [
              _vm._v(_vm._s(_vm.$t("chatbotv2.questionVariants"))),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "numbers" },
              [
                _vm._l(_vm.value.questions, function (_, index) {
                  return _c(
                    "div",
                    {
                      key: "number-" + index,
                      staticClass: "number",
                      class: { active: index === _vm.currentIndex },
                      on: {
                        click: function ($event) {
                          _vm.currentIndex = index
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(index + 1) +
                          "\n                    "
                      ),
                    ]
                  )
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "number",
                    on: { click: _vm.addNewQuestionVariant },
                  },
                  [_vm._v("+")]
                ),
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              key: _vm.stateId + "-" + _vm.currentIndex,
              staticClass: "message-content",
            },
            [
              _vm.value.questions.length > 1
                ? _c(
                    "div",
                    { staticClass: "message-variants-remove" },
                    [
                      _c(
                        "md-button",
                        {
                          staticClass: "md-icon-button md-mini",
                          on: {
                            click: function ($event) {
                              return _vm.deleteQuestionVariant(_vm.currentIndex)
                            },
                          },
                        },
                        [_c("md-icon", [_vm._v("delete_outline")])],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("TiptapEditor", {
                key: _vm.stateId + "-" + _vm.currentIndex,
                attrs: {
                  placeholder: _vm.$t("chatbotv2.enterBotResponseHere"),
                  "show-attributes": true,
                  "show-emoji": true,
                },
                model: {
                  value: _vm.value.questions[_vm.currentIndex],
                  callback: function ($$v) {
                    _vm.$set(_vm.value.questions, _vm.currentIndex, $$v)
                  },
                  expression: "value.questions[currentIndex]",
                },
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "entity-picker-section" },
          [
            _c("span", { staticClass: "sectionTitle" }, [
              _vm._v(_vm._s(_vm.$t("chatbotv2.validateResponseWithEntity"))),
            ]),
            _vm._v(" "),
            _c(
              "a-popover",
              {
                attrs: { trigger: "click", overlayClassName: "no-padding" },
                model: {
                  value: _vm.entityPickerVisible,
                  callback: function ($$v) {
                    _vm.entityPickerVisible = $$v
                  },
                  expression: "entityPickerVisible",
                },
              },
              [
                _c(
                  "div",
                  { attrs: { slot: "content" }, slot: "content" },
                  [
                    _c("ValidationEntityPicker", {
                      attrs: {
                        "default-selected": _vm.value.validation,
                        pick: _vm.onValidationEntityPicked,
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "entity-input" }, [
                  _c("div", { staticClass: "entity-input-text-wrapper" }, [
                    _vm.$_.isEmpty(_vm.value.validation)
                      ? _c("div", { staticClass: "entity-input-placeholder" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.$t("chatbotv2.selectReplyType")) +
                              "\n                        "
                          ),
                        ])
                      : _c(
                          "div",
                          {
                            staticClass: "single-entity-style",
                            class: { active: _vm.entityPickerVisible },
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "chatbotv2." +
                                      _vm.getValidationEntity(
                                        _vm.value.validation
                                      ).value
                                  )
                                )
                              ),
                            ]),
                          ]
                        ),
                  ]),
                  _vm._v(" "),
                  !_vm.$_.isEmpty(_vm.value.validation)
                    ? _c("span", { staticClass: "material-icons" }, [
                        _vm._v(" expand_more "),
                      ])
                    : _vm._e(),
                ]),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _vm.value.validation === "regex"
          ? _c(
              "div",
              { staticClass: "entity-picker-section" },
              [
                _c("div", { staticClass: "sectionTitle" }, [
                  _vm._v("Regex Girin veya Hazır Seçin"),
                ]),
                _vm._v(" "),
                _c(
                  "a-popover",
                  {
                    attrs: {
                      visible: _vm.regexPickerVisible,
                      overlayClassName: "no-padding",
                    },
                    on: {
                      visibleChange: function (visible) {
                        return (_vm.regexPickerVisible = false)
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      { attrs: { slot: "content" }, slot: "content" },
                      [
                        _c("RegexPicker", {
                          attrs: {
                            "default-selected": _vm.value.regex,
                            pick: _vm.onRegexPicked,
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "entity-input" }, [
                      _c(
                        "div",
                        { staticClass: "entity-input-text-wrapper" },
                        [
                          _c("TiptapEditor", {
                            key: _vm.stateId + "-" + _vm.currentIndex,
                            attrs: {
                              placeholder: "Regex girin",
                              "show-attributes": true,
                              "show-emoji": false,
                            },
                            model: {
                              value: _vm.value.regex,
                              callback: function ($$v) {
                                _vm.$set(_vm.value, "regex", $$v)
                              },
                              expression: "value.regex",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "material-icons",
                          on: {
                            click: function ($event) {
                              _vm.regexPickerVisible = !_vm.regexPickerVisible
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                        expand_more\n                    "
                          ),
                        ]
                      ),
                    ]),
                  ]
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "attribute-picker-section" },
          [
            _c("span", { staticClass: "sectionTitle" }, [
              _vm._v(" " + _vm._s(_vm.$t("chatbotv2.saveResposeToAttribute"))),
            ]),
            _vm._v(" "),
            _c(
              "a-popover",
              {
                attrs: { trigger: "click", overlayClassName: "no-padding" },
                model: {
                  value: _vm.attributePickerVisible,
                  callback: function ($$v) {
                    _vm.attributePickerVisible = $$v
                  },
                  expression: "attributePickerVisible",
                },
              },
              [
                _c(
                  "div",
                  { attrs: { slot: "content" }, slot: "content" },
                  [
                    _c("AttributePicker", {
                      attrs: {
                        "default-selected": _vm.value.set,
                        pick: _vm.onAttributePicked,
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "attribute-input" }, [
                  _c("div", { staticClass: "attribute-input-text-wrapper" }, [
                    _vm.$_.isEmpty(_vm.value.set)
                      ? _c(
                          "div",
                          { staticClass: "attribute-input-placeholder" },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.$t("chatbotv2.chooseAttributeType")
                                ) +
                                "\n                        "
                            ),
                          ]
                        )
                      : _c(
                          "div",
                          {
                            staticClass: "single-attribute-style",
                            class: { active: _vm.attributePickerVisible },
                          },
                          [
                            _c("AttributeIconPreview", {
                              attrs: { attribute: _vm.value.set },
                            }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    ("" + _vm.value.set).startsWith(
                                      "akinon_"
                                    ) ||
                                      ("" + _vm.value.set).startsWith(
                                        "probel_"
                                      ) ||
                                      _vm.Attributes.includes(_vm.value.set)
                                      ? _vm.$t(
                                          "chatbotv2.attr." + _vm.value.set
                                        )
                                      : _vm.value.set.startsWith(
                                          "contact_property_"
                                        )
                                      ? _vm.visitorContactAttributes[
                                          _vm.value.set.replace(
                                            "contact_property_",
                                            ""
                                          )
                                        ]
                                      : _vm.value.set
                                  ) +
                                  "\n                            "
                              ),
                            ]),
                          ],
                          1
                        ),
                  ]),
                  _vm._v(" "),
                  !_vm.$_.isEmpty(_vm.value.set)
                    ? _c("span", { staticClass: "material-icons" }, [
                        _vm._v(" expand_more "),
                      ])
                    : _vm._e(),
                ]),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "failure-section" },
          [
            _c("span", { staticClass: "sectionTitle" }, [
              _vm._v(_vm._s(_vm.$t("chatbotv2.actionOnFailureInput"))),
            ]),
            _vm._v(" "),
            _c(
              "a-select",
              {
                staticClass: "select-failure-action",
                attrs: { value: _vm.value.onFailure },
                on: {
                  change: function (e) {
                    return (_vm.value.onFailure = e)
                  },
                },
              },
              [
                _vm.showNextQuestionAction
                  ? _c(
                      "a-select-option",
                      { attrs: { value: "go_to_next_question" } },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$t("chatbotv2.askNextQuestion")) +
                            "\n                "
                        ),
                      ]
                    )
                  : _c(
                      "a-select-option",
                      { attrs: { value: "go_to_success" } },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("chatbotv2.goToSuccessBlock")) +
                            "\n                "
                        ),
                      ]
                    ),
                _vm._v(" "),
                _c("a-select-option", { attrs: { value: "go_to_failure" } }, [
                  _vm._v(_vm._s(_vm.$t("chatbotv2.goToFailureBlock"))),
                ]),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "retry-section mt-3" }, [
          _c(
            "div",
            {
              staticClass:
                "d-flex flex-row align-items-center justify-content-between",
            },
            [
              _c(
                "span",
                [
                  _vm.$i18n.locale === "tr"
                    ? _c("span", [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("chatbotv2.retrySectionText")) +
                            " "
                        ),
                      ])
                    : _vm.$i18n.locale === "en" || _vm.$i18n.locale === "ru"
                    ? _c("span", [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.$t("chatbotv2.retrySectionTextPart")) +
                            "\n                    "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "a-popover",
                    {
                      attrs: {
                        trigger: "click",
                        overlayClassName: "no-padding",
                      },
                      model: {
                        value: _vm.retryCountPickerVisible,
                        callback: function ($$v) {
                          _vm.retryCountPickerVisible = $$v
                        },
                        expression: "retryCountPickerVisible",
                      },
                    },
                    [
                      _c(
                        "div",
                        { attrs: { slot: "content" }, slot: "content" },
                        [
                          _c("div", { staticClass: "list-wrapper" }, [
                            _c("div", { staticClass: "list" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "list-item",
                                  on: {
                                    click: function ($event) {
                                      return _vm.changeRetryCount()
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                                        " +
                                      _vm._s(_vm.$t("chatbotv2.untilFilled")) +
                                      "\n                                    "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "list-item",
                                  on: {
                                    click: function ($event) {
                                      return _vm.changeRetryCount("1")
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                                        " +
                                      _vm._s(_vm.$t("chatbotv2.time1")) +
                                      "\n                                    "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "list-item",
                                  on: {
                                    click: function ($event) {
                                      return _vm.changeRetryCount("2")
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                                        " +
                                      _vm._s(_vm.$t("chatbotv2.time2")) +
                                      "\n                                    "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "list-item",
                                  on: {
                                    click: function ($event) {
                                      return _vm.changeRetryCount("3")
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                                        " +
                                      _vm._s(_vm.$t("chatbotv2.time3")) +
                                      "\n                                    "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "list-item",
                                  on: {
                                    click: function ($event) {
                                      return _vm.changeRetryCount("4")
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                                        " +
                                      _vm._s(_vm.$t("chatbotv2.time4")) +
                                      "\n                                    "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "list-item",
                                  on: {
                                    click: function ($event) {
                                      return _vm.changeRetryCount("5")
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                                        " +
                                      _vm._s(_vm.$t("chatbotv2.time5")) +
                                      "\n                                    "
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "text-primary retry-info" }, [
                        _vm._v(
                          _vm._s(
                            !!_vm.value.retry && !isNaN(_vm.value.retry)
                              ? _vm.$t("chatbotv2.time" + _vm.value.retry)
                              : _vm.$t("chatbotv2.untilFilled")
                          )
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.$i18n.locale === "en" || _vm.$i18n.locale === "ru"
                    ? _c("span", [
                        _vm._v(_vm._s(_vm.$t("chatbotv2.retrySectionText"))),
                      ])
                    : _vm.$i18n.locale === "tr"
                    ? _c("span", [
                        _vm._v(
                          _vm._s(_vm.$t("chatbotv2.retrySectionTextPart"))
                        ),
                      ])
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "span",
                { staticClass: "d-flex flex-row align-items-center" },
                [
                  _c(
                    "span",
                    {
                      staticClass:
                        "material-icons text-primary retry-icons mr-1",
                    },
                    [_vm._v(" repeat_on ")]
                  ),
                  _vm._v(" "),
                  !!_vm.value.retry && !isNaN(_vm.value.retry)
                    ? _c(
                        "span",
                        {
                          staticClass:
                            "material-icons text-primary retry-icons",
                        },
                        [
                          _vm._v(
                            "\n                        filter_" +
                              _vm._s("" + _vm.value.retry) +
                              "\n                    "
                          ),
                        ]
                      )
                    : _c(
                        "span",
                        {
                          staticClass:
                            "material-icons text-primary retry-icons",
                        },
                        [_vm._v(" all_inclusive ")]
                      ),
                ]
              ),
            ]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }